import { render, staticRenderFns } from "./TypeWellReplay.vue?vue&type=template&id=b6a4035a&scoped=true"
import script from "./TypeWellReplay.vue?vue&type=script&lang=ts"
export * from "./TypeWellReplay.vue?vue&type=script&lang=ts"
import style0 from "./TypeWellReplay.vue?vue&type=style&index=0&id=b6a4035a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a4035a",
  null
  
)

export default component.exports